import { render, staticRenderFns } from "./RegReportAdd.vue?vue&type=template&id=3e034ada"
import script from "./RegReportAdd.vue?vue&type=script&lang=js"
export * from "./RegReportAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports